import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FoodService } from 'app/services';
import { FoodProductStatus } from 'app/models';

@Component({
    selector: 'edit-food-modifier',
    templateUrl: './edit-food-modifier.component.html',
    styleUrls: ['./edit-food-modifier.component.scss'],
    providers: [MessageService]
})
export class EditFoodModifierComponent implements OnInit {
    @Input()
    public modifierId: number = 0;

    @Input()
    public restaurants: Array<any> = [];

    @Input()
    public onSave: () => void = () => { };

    @Input()
    public onHide: () => void = () => { };

    public modifier: any = {};

    public isEnabled: boolean = true;

    constructor(
        private messageService: MessageService,
        private foodService: FoodService) {
    }

    ngOnInit(): void {
        if (this.modifierId) {
            this.getModifier();
        }
    }

    private getModifier(): void {
        const dto = {
            Id: this.modifierId
        };

        this.foodService.getModifierById(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.modifier = data;

                this.isEnabled = this.modifier.StatusId === FoodProductStatus.Enabled;
            });
    }

    public handleUploadClick(): void {
        document.getElementById('idImgInput')?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.modifier.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public handleSideBarHide(): void {
        this.onHide();
    }

    public handleSaveClick(): void {
        let promise: Promise<any> = Promise.resolve();

        this.modifier.StatusId = this.isEnabled ? FoodProductStatus.Enabled : FoodProductStatus.Disabled;

        if (this.modifierId) {
            promise = this.foodService.updateModifier(this.modifier, this.messageService);
        } else {
            promise = this.foodService.addModifier(this.modifier, this.messageService);
        }

        promise.then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.onSave();
        });
    }
}
